import FormWizard1Container from "../../../../../Components/Forms&Table/Forms/FormLayout/FormWizard1/FormWizard1Container";

const FormWizard1 = () => {
  return <FormWizard1Container />;
};

export default FormWizard1;
